import
    {
        Component
    } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { CoreApplication } from './providers/core-application';


@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: [ 'app.component.scss' ],
})
export class AppComponent
{
    //#region Constructor

    /**
     * Class constructor
     */
    constructor
        (
            private coreApp: CoreApplication,
            private navCtrl: NavController
        )
    {
        this.registerApplicationIdleHandler();
    }

    //#endregion

    //#region Properties


    //#endregion

    //#region Methods

    /**
     * Register to the application idle observable
     */
    private registerApplicationIdleHandler(): Subscription
    {
        // subscribe to the requestLogin observable and show the login screen accordingly
        return this.coreApp.requestLogin.subscribe(() =>
        {
            this.navigateToLoginPage();
        });
    }

    /**
     * Navigate to the Landing or PIN login page accordingly
     */
    private navigateToLoginPage(): Promise<boolean>
    {
        return this.navCtrl.navigateRoot('/landing');
    }

    //#endregion
}

